const enum FeatureFlags {
  SHOW_CALL_PLAN_TAB = "SHOW_CALL_PLAN_TAB",
  SHOW_NEW_ACTIVITY_LIBRARY = "SHOW_NEW_ACTIVITY_LIBRARY",
  DISABLE_CREATE_PLAYLIST = "DISABLE_CREATE_PLAYLIST",
  FORCE_PLAYLISTS_TAB = "FORCE_PLAYLISTS_TAB",
  LINK_ACTIVITY_VOICE_MESSAGE = "LINK_ACTIVITY_VOICE_MESSAGE",
}

export const FeatureFlagDefaults: Record<FeatureFlags, boolean> = {
  [FeatureFlags.SHOW_CALL_PLAN_TAB]: false,
  [FeatureFlags.SHOW_NEW_ACTIVITY_LIBRARY]: false,
  [FeatureFlags.DISABLE_CREATE_PLAYLIST]: false,
  [FeatureFlags.FORCE_PLAYLISTS_TAB]: true,
  [FeatureFlags.LINK_ACTIVITY_VOICE_MESSAGE]: true,
};

export default FeatureFlags;
